import React from 'react';
import { Dialog } from '../../shared/custom-ui';
import { V2Button } from '../../shared/custom-ui/v2-components';

type RecModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onSave: () => void;
    onCancel: () => void;
    transcript: string;
    loading: boolean;
    canSave: boolean;
};

const RecModal: React.FC<RecModalProps> = ({
    isOpen,
    onClose,
    onSave,
    transcript,
    loading,
    canSave,
    onCancel,
}) => {
    return (
        <Dialog
            isOpen={isOpen}
            onClose={onClose}
            title="Transcription Data"
            size="large"
            showCloseButton
            footer={
                <div className="flex items-center justify-end gap-3">
                    <V2Button variant="ghost" onClick={onCancel}>
                        Cancel
                    </V2Button>
                    <V2Button
                        variant="primary"
                        onClick={onSave}
                        disabled={loading || !canSave}
                    >
                        {loading ? 'Saving…' : 'Save'}
                    </V2Button>
                </div>
            }
        >
            {/* Transcript textarea — theme-aware, no hardcoded colours */}
            <textarea
                value={transcript}
                readOnly
                rows={10}
                className={[
                    'w-full resize-none rounded-[var(--v2-radius-md)] p-4',
                    'bg-[var(--v2-bg-inset)] text-[var(--v2-text-primary)] text-[14.5px] leading-relaxed',
                    'border border-[var(--v2-border-card)]',
                    'placeholder:text-[var(--v2-text-muted)]',
                    'focus:outline-none focus:ring-2 focus:ring-[var(--v2-primary-500)]/30 focus:border-[var(--v2-primary-500)]',
                    'transition-colors duration-[var(--v2-duration-fast)]',
                    'custom-scrollbar',
                ].join(' ')}
                placeholder="Your transcription will appear here…"
            />
        </Dialog>
    );
};

export default RecModal;
